module.exports = __webpack_public_path__ + "img/购物icon.21da5279.svg";